<template>
    <div>
        <CompassTable :isCheckable="false" class="unit-settings-translation-table">
            <CompassTableHead>
                <CompassTableHeadCell></CompassTableHeadCell>
                <CompassTableHeadCell>
                    {{ $t.__('common.labels.value') }}
                </CompassTableHeadCell>
            </CompassTableHead>
            <SaasDraggable
                v-model="localUnits"
                dragClass="unit-settings-table__row"
                :isTable="true"
                :disabled="!editMode"
                handle=".unit-settings-translation-table__drag-handle"
                @update:model-value="handleSortUpdate"
            >
                <CompassTableRow
                    v-for="unitItem in units"
                    :key="unitItem.id"
                    class="unit-settings-table__row"
                >
                    <CompassTableBodyCell
                        class="unit-settings-translation-table__drag-column"
                        :width="64"
                    >
                        <div class="unit-settings-translation-table__drag-handle">
                            <CompassIcon
                                icon="drag-and-drop"
                                :type="isEditable ? 'primary' : 'disabled'"
                            />
                        </div>
                    </CompassTableBodyCell>
                    <CompassTableBodyCell :width="220">
                        <span
                            v-if="!editMode"
                            :class="{
                                'typographies-paragraph-medium-regular': true,
                                'unit-settings-translation-table__value--is-default':
                                    isDefaultValue(unitItem),
                            }"
                        >
                            {{ getTranslatedValue(unitItem).value }}
                        </span>
                        <div v-else class="unit-settings-translation-table__value-wrapper">
                            <CompassInput v-model="getTranslation(unitItem).value" />
                            <span
                                class="unit-settings-translation-table__value-default typographies-paragraph-medium-regular"
                            >
                                {{ $t.__('common.labels.default') }} : {{ unitItem.label }}
                            </span>
                        </div>
                    </CompassTableBodyCell>
                </CompassTableRow>
            </SaasDraggable>
        </CompassTable>
        <AddUnitRow v-if="editMode" @addUnit="addUnit" />
    </div>
</template>
<script>
import SaasDraggable from 'vcomponents/common/SaasDraggable.vue';
import AddUnitRow from 'vcomponents/preferences/Units/AddUnitRow.vue';

export default {
    components: {
        SaasDraggable,
        AddUnitRow,
    },
    props: {
        units: {
            type: Array,
            required: true,
        },
        isEditable: {
            type: Boolean,
            default: false,
        },
        editMode: {
            type: Boolean,
            default: false,
        },
        language: {
            type: Number,
            required: true,
        },
    },
    emits: ['sort', 'addUnit'],
    data() {
        return {
            localUnits: this.units,
        };
    },
    watch: {
        units(newValues) {
            this.localUnits = newValues;
        },
    },
    methods: {
        isDefaultValue(unit) {
            return this.getTranslatedValue(unit).isDefault;
        },
        getTranslatedValue(unit) {
            const translation = unit._embed.translations.find(
                (item) => item.lang_id === this.language && item.value !== '',
            );
            return {
                value: translation ? translation.value : unit.label,
                isDefault: !translation,
            };
        },
        getTranslation(unit) {
            return unit._embed.translations.find((item) => item.lang_id === this.language);
        },
        handleSortUpdate(newOrder) {
            this.$emit('sort', newOrder);
        },
        addUnit() {
            this.$emit('addUnit');
        },
    },
};
</script>
<style>
.unit-settings-table__row.sortable-drag {
    .compass-table__cell-container {
        min-height: 56px;
        padding: var(--spacing-2) var(--spacing-3);
    }
}
</style>
<style lang="scss" scoped>
.unit-settings-translation-table {
    border-bottom: 1px solid var(--colors-common-border-lighter);

    &::v-deep {
        .compass-table__cell-container,
        .compass-form-item {
            width: 100%;
        }
    }

    &__drag {
        &-column {
            white-space: nowrap;
            width: 1%;
        }

        &-handle {
            align-items: center;
            display: flex;
            flex: 1;
            justify-content: center;
            min-height: 32px;
            width: 32px;
        }
    }

    &__value {
        &--is-default {
            color: var(--colors-common-text-standard-placeholder);
            max-width: 250px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        &-wrapper {
            align-items: center;
            display: flex;
            gap: var(--spacing-3);
        }

        &-default {
            color: var(--colors-common-text-standard-caption);
            max-width: 250px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
}
</style>
